var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.519231 4.15385C0.519231 2.14651 2.1465 0.519231 4.15385 0.519231H29.0765C31.0838 0.519231 32.7111 2.1465 32.7111 4.15385V19.7304C32.7111 21.7378 31.0838 23.3651 29.0765 23.3651H4.15385C2.1465 23.3651 0.519231 21.7378 0.519231 19.7304V4.15385Z",
    fill: "#12343F",
    stroke: "#00AEEF",
    strokeWidth: 1.03846
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 9V8.375H11.5V7.125H22.75V5.875H22.125V5.25H10.25V5.875H9.625V17.125H10.25V17.75H22.75V17.125H23.375V9H22.75ZM22.125 13.375H21.5V14H20.25V13.375H19.625V12.125H20.25V11.5H21.5V12.125H22.125V13.375Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3aa9a08965695588f50ebb8bc624e905.svg";
export { ForwardRef as ReactComponent };